var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.componentIs, {
    tag: "component"
  }, [_vm._t("default", null, null, {
    icon: _vm.icon,
    button: _vm.button,
    message: _vm.message,
    disabled: _vm.disabled
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }